import { Center, Text } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useEffect, useRef } from "react";
import { useIsMobile, useIsTouch } from "../../../utils/useIsMobile";



export function InfoControls(props) {
    const isTouch = useIsTouch()


    return (
        <group {...props}>
            {!isTouch && (
                <group>
                    <Text color="black" font="font/Mattone-Regular.woff">
                        W/Z
                    </Text>
                    <Text color="black" position={[0, -1.3, 0]} font="font/Mattone-Regular.woff">
                        S
                    </Text>
                    <Text color="black" position={[-1.3, -1.3, 0]} font="font/Mattone-Regular.woff">
                        Q
                    </Text>
                    <Text color="black" position={[1.3, -1.3, 0]} font="font/Mattone-Regular.woff">
                        D
                    </Text>
                    <Text
                        color="black"
                        position={[0, -2.3, 0]}
                        fontSize={0.3}
                        font="font/Mattone-Regular.woff"
                    >
                        use keyboard to move
                    </Text>
                </group>
            )}

            {isTouch && (
                <group>
                    <Text
                        color="black"
                        position={[0, 0, 0]}
                        fontSize={0.3}
                        font="font/Mattone-Regular.woff"
                    >
                        use the virtual joystick to move
                    </Text>
                </group>
            )}
        </group>
    )

}

export function MyWorkText({ curveRadius, position, rotation }) {
    const textRef = useRef()
    const curveOffsetRef = useRef()
    useFrame((_, delta) => {
        textRef.current.rotation.y += 0.06 * delta
    })

    useEffect(() => {
        if (!curveOffsetRef.current) return
        curveOffsetRef.current.position.z = -curveRadius
    }, [curveRadius])
    return (
        <group ref={textRef} position={position} rotation={rotation} scale={0.5}>
            <Center>
                <Text
                    ref={curveOffsetRef}
                    curveRadius={curveRadius}
                    color={"black"}
                    font='font/Mattone-Regular.woff'
                    fontSize={1.5}
                    anchorX="center"
                    anchorY="middle"
                    textAlign="center"
                >
                    MY WORKS - MY WORKS -
                </Text>
            </Center>
        </group>
    )
}